import { render, staticRenderFns } from "./NotificationAppointmentApproved.vue?vue&type=template&id=e4bb33c0&scoped=true&"
import script from "./NotificationAppointmentApproved.vue?vue&type=script&lang=ts&"
export * from "./NotificationAppointmentApproved.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationAppointmentApproved.vue?vue&type=style&index=0&id=e4bb33c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bb33c0",
  null
  
)

export default component.exports